import { render, staticRenderFns } from "./menuGroup.vue?vue&type=template&id=91d9194e&scoped=true&"
import script from "./menuGroup.vue?vue&type=script&lang=js&"
export * from "./menuGroup.vue?vue&type=script&lang=js&"
import style0 from "./menuGroup.vue?vue&type=style&index=0&id=91d9194e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91d9194e",
  null
  
)

export default component.exports